import moment from 'moment-mini';

let commonHttpStatusCodes = {
    400: 'Bad Request.',
    401: 'Unauthorized.',
    403: 'Forbidden.',
    404: 'Not Found.',
    500: 'Internal Server Error.',
    502: 'Bad Gateway.',
    503: 'Service Unavailable.',
    504: 'Gateway Timeout.',
};

export default {
    computed: {
        pagePath() {
            let url = this.$inertia.page.url.split('?');
            return url[0];
        },
    },
    methods: {
        apiHandleError(error) {
            if (error.hasOwnProperty('response')) {
                let response = error.response || {};
                let data = response.data || {};
                let message = data.message ||
                    response.statusText ||
                    commonHttpStatusCodes[response.status] ||
                    'Unknown Error.';
                this.toast(message, "error");
            } else {
                throw error;
            }
        },
        /**
         * Formats a unix timestamp
         *
         * @param int|string|moment timestamp
         * @param format, nothing=MMM D, YYYY, full=adds time, human=todo, other=format to use
         * @param asUtc
         * @returns {string|*}
         */
        formatStamp(timestamp, format, asUtc) {
            let dt;
            if (!timestamp) {
                return 'n/a';
            }
            if (typeof timestamp === 'string') {
                dt = moment(timestamp);
            } else {
                if (timestamp instanceof moment) {
                    dt = timestamp.utc();
                } else {
                    dt = moment.unix(timestamp).utc();
                }
                if (!asUtc) {
                    // look to logged in data for timezone & timezone offset
                    let zone = (this.$page.user && this.$page.user.timezone) ? this.$page.user.timezone : 'local';
                    let offset = (zone !== 'local' && this.$page.user.timezoneOffset) ? this.$page.user.timezoneOffset : 0;
                    if (zone === 'local') {
                        offset = (new Date()).getTimezoneOffset();  // browser's timezone offset
                    }
                    dt.utcOffset(offset);
                }
            }
            if (!format) {
                format = "MMM D, YYYY";
            } else if (format === 'full') {
                format = "MMM D, YYYY h:mma";
            } else if (format === 'human') {
                return this.formatStampHuman(timestamp);
            }
            return dt.format(format);
        },
        numberFormat(number, decimals) {
            let parts = Number(number).toFixed(decimals).split('.');
            parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            return parts.join('.');
        },
        processPageToasts() {
            let toasts = this.$page['toasts'];
            if (toasts) {
                this.toast(toasts['message'], toasts['type']);
                this.$page['toasts'] = null;
            }
        },
        postHadError() {
            let errors = Object.assign({}, this.$page['errors']);
            let numErrors = Object.keys(errors).length;
            return numErrors > 0;
        },
        postHandleErrors() {
            let errors = Object.assign({}, this.$page['errors']);
            let numErrors = Object.keys(errors).length;
            if (numErrors > 0) {
                this.toast(numErrors === 1 ? 'An error occurred!' : 'Errors occurred!', 'error');
                this.scrollToError(errors);
            }
            return errors;
        },
        routeIs(path) {
            return this.pagePath === path;
        },
        routeOn(path) {
            return this.startsWith(this.pagePath, path);
        },
        scrollToElement(element) {
            if (element) {
                element.scrollIntoView({behavior: 'smooth'});
                element.focus();
            }
        },
        scrollToError(errors) {
            let errorKeys = Object.keys(errors);
            if (errorKeys.length) {
                this.scrollToId(errorKeys[0].replace('.', '-'));
            }
        },
        scrollToId(id) {
            if (id) {
                this.scrollToElement(document.querySelector('#' + id));
            }
        },
        startsWith(string, target) {
            string += ''; // force to strings
            target += '';
            return string.slice(0, target.length) === target;
        },
        stopLoading() {
            if (this.$refs.gadget && this.$refs.gadget.$data._gadgetBox) {
                this.$nextTick(() => {
                    this.$refs.gadget.stopLoading();
                });
                return;
            }
            console.error('Did you add a ref="gadget" to <gadget-box>');
        },
        toast(message, type) {
            this.$toasted.show(message, {type: type ? type : 'success'});
        },
    }
}